(function (viwebb) {
    viwebb.cookie = viwebb.cookie || {};

    viwebb.cookie.acceptCookieUsage = function (cookieUsageElement, cookieUsageAccept) {
        if (!cookieUsageElement.length || !cookieUsageAccept.length) {
            return;
        }

        var cookies = document.cookie;

        if (cookies.indexOf('viwebb-cookies-accepted') > -1) {
            return;
        }

        cookieUsageElement.removeClass('hidden');

        cookieUsageAccept.on('click', function () {
            var expiration = new Date();
            // Add one year
            expiration.setTime(expiration.getTime() + 365 * 86400000);

            document.cookie = 'viwebb-cookies-accepted=1;expires=' + expiration.toUTCString();
            cookieUsageElement.addClass('hidden');
        });
    };
})(window.viwebb = window.viwebb || {});